<div class="popup-wrapper">
  <div class="popup-box" (appClickOutside)="closePopup()">
    <div class="popup-header">
      <div class="popup-header-title">
        <span>ICAP Inquiry Forms</span>
        <a href="javascript:void(0)" class="close" (click)="closePopup()"> </a>
      </div>
    </div>
    <div class="popup-content">
      <div class="popup-data-wrapper">
        @for (lead of Leads; track $index) {
          <div class="each-popup-data">
            <div class="label-text">{{ lead.unique_id }}</div>
            <div class="value">
              {{ lead.company_name }}
            </div>
            <div class="form-link">
              <a
                class="link-text"
                [href]="idUrlMap[lead.unique_id]"
                target="_blank"
                >{{ idUrlMap[lead.unique_id] }}</a
              >
              <a
                class="copy-btn"
                href="javascript:void(0)"
                (click)="copyFormUrl(lead)"
              >
                <app-svg-icon
                  [iconName]="'copy.svg'"
                  [height]="'12px'"
                  [width]="'12px'"
                  [style.fill]="'#000'"
                  [style.margin-right]="'5px'"
                ></app-svg-icon>
                <span id="{{ lead.unique_id }}">Copy</span>
              </a>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
